/* eslint-disable no-console */
import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import XLSX from 'xlsx';
import * as Yup from 'yup';
import Firebase from '../../../services/firebase';
import Button from '../../../components/button/index.tsx';
import UsuarioContext from '../../../context/usuario.context';
import PosicoesContext from '../../../context/posicoes.context';
import FirebaseContext from '../../../context/firebase.context';
import Dados from '../../../data/data.json';
import { FormataTelefone, InverterDataAtualUS } from '../../../functions/helper';
import { notify } from '../../../functions/notifications';
import Loader from '../../../assets/loader.gif';
import VendaConfirmada from '../images/confirm.png';
import './newSale.scss';
import DragAndDrop from './scriptDragAndDrop';
import { Certificado } from '../../../components/modals';
import InvalidImg from '../../../assets/invalid.png';
import { NotificarCompraSegura } from '../../../services/apiWhats';

function NewSale() {
  const { setIsScreenCertifield } = useContext(PosicoesContext);
  const { expectadores } = useContext(FirebaseContext);
  const { usuario, setUsuario, usuario: { uid } } = useContext(UsuarioContext);
  const history = useHistory();
  const [data, setData] = useState([]);
  const [saving, setSaving] = useState(false);
  const [showMessage, setShowMessage] = useState({
    cliente: '',
    shoe: false,
  });
  const [screen, setScreen] = useState('sale');
  const [newObj, setNewObj] = useState([]);
  const [cliente, setCliente] = useState(
    {
      empreendimento: 'Não encontrado',
      culturaTratada: 'Algodão',
      produtoAplicado: 'Ad Foliar',
      urlVenda: '',
      uuid: '',
      uploadCompleted: {
        decaAplicador: { valor: false },
        decaProdutor: { valor: false },
        receituario: { valor: false },
        notaFiscal: { valor: false },
      },
      modalidade: [],
      filesUpload: {
        decaAplicador: [],
        decaProdutor: [],
        receituario: [],
        notaFiscal: [],
      },
    },
  );

  useEffect(() => {
    setIsScreenCertifield(false);
  }, []);

  const SheetJSFT = [
    'xlsx',
    'xlsb',
    'xlsm',
    'xls',
    'xml',
    'csv',
    'txt',
    'ods',
    'fods',
    'uos',
    'sylk',
    'dif',
    'dbf',
    'prn',
    'qpw',
    '123',
    'wb*',
    'wq*',
    'html',
    'htm',
  ].map((x) => `.${x}`)
    .join(',');

  function uploadFiles() {
    setSaving(true);
    const itemsName = ['decaAplicador', 'decaProdutor', 'notaFiscal', 'receituario'];
    itemsName.forEach((item) => {
      const arquivo = cliente.filesUpload[item][0];
      const ref = Firebase.storage().ref(`arquivos/${uid}`);
      ref.child(arquivo.name)
        .put(arquivo).then(() => {
          ref.child(arquivo.name)
            .getDownloadURL().then((urlDownload) => { // (urlDownload) => {
              setCliente((prevState) => ({
                ...prevState,
                filesUpload: {
                  ...prevState.filesUpload,
                  [item]: urlDownload,
                },
                uploadCompleted: {
                  ...prevState.uploadCompleted,
                  [item]: { valor: true },
                },
              }));
            });
        });
    });
  }

  function updateUser() {
    const newUser = {
      ...usuario,
      vendas: [
        ...usuario.vendas,
        {
          vendedor: {
            vendedor: usuario.nome,
            vendedorEndereco: usuario.endereco,
            vendedorCidade: usuario.cidade,
            vendedorEstado: usuario.estado,
            vendedorCelular: usuario.celular,
            vendedorEmail: usuario.email,
            uidVendedor: uid,
          },
          [cliente.uid]: {
            ...cliente,
            urlVenda: `https://agsafe.netlify.app/authentication/${cliente.uid}/key=${uid}`,
          },
        },
      ],
    };
    NotificarCompraSegura({
      celular: cliente.telefone,
      nome: cliente.empreendimento,
      link: `https://agsafe.netlify.app/authentication/${cliente.uid}/key=${uid}`,
    });
    expectadores.forEach(({ nome, celular }) => {
      NotificarCompraSegura({
        celular, nome, link: `https://agsafe.netlify.app/authentication/${cliente.uid}/key=${uid}`,
      });
    });
    Firebase.firestore().collection('users').doc(uid).update(newUser)
      .then(() => {
        Firebase.firestore().collection('certificates').doc(uid).update({
          vendas: [
            ...usuario.vendas,
            {
              vendedor: {
                vendedor: usuario.nome,
                vendedorEndereco: usuario.endereco,
                vendedorCidade: usuario.cidade,
                vendedorEstado: usuario.estado,
                vendedorCelular: usuario.celular,
                vendedorEmail: usuario.email,
                uidVendedor: uid,
              },
              [cliente.uid]: {
                ...cliente,
                urlVenda: `https://agsafe.netlify.app/authentication/${cliente.uid}/key=${uid}`,
              },
            },
          ],
        })
          .then(() => {
            setUsuario(newUser,
              setSaving(false, setScreen('completed')),
              notify('success', 'Venda realizada com sucesso.'));
          })
          .catch((erro) => {
            console.log(erro);
            setUsuario(newUser,
              setSaving(false, setScreen('completed')),
              notify('success', 'Venda realizada com sucesso.'));
          });
      })
      .catch(() => {
        setUsuario(newUser,
          setSaving(false, setScreen('completed')),
          notify('success', 'Venda realizada com sucesso.'));
      });
  }
  async function enabledSave() {
    const checkValues = Yup.object().shape({
      produtoAplicado: Yup.string().required(),
      culturaTratada: Yup.string().required(),
      telefone: Yup.string().required(),
      dataCompra: Yup.string().required(),
      empreendimento: Yup.string().required(),
    });

    checkValues.validate(cliente).then(() => {
      if (cliente.modalidade.length === 0) {
        throw new Error('modalidade');
      }
      if (cliente.filesUpload.decaAplicador.length === 0) {
        throw new Error('decaAplicador');
      }
      if (cliente.filesUpload.decaProdutor.length === 0) {
        throw new Error('decaProdutor');
      }
      if (cliente.filesUpload.receituario.length === 0) {
        throw new Error('receituario');
      }
      if (cliente.filesUpload.notaFiscal.length === 0) {
        throw new Error('notaFiscal');
      }
      uploadFiles();
    }).catch((err) => {
      const { message } = err;
      const verificar = message.split(' ')[0];
      switch (verificar) {
        case 'empreendimento':
          notify('error', 'Informe o Aplicador/Estabelecimento Rural');
          break;
        case 'dataCompra':
          notify('error', 'Informe a data da compra.');
          break;
        case 'telefone':
          notify('error', 'Informe o telefone do Aplicador/Estabelecimento Rural.');
          break;
        case 'modalidade':
          notify('error', 'Informe a modalidade da aplicação.');
          break;
        case 'decaAplicador':
          notify('error', 'Envie a Declaração do Cadatro Estadual de Aplicador de Agrotóxicos.');
          break;
        case 'decaProdutor':
          notify('error', 'Envie a Declaração do Produtor Rural.');
          break;
        case 'receituario':
          notify('error', 'Envie o Receituário Agronômico.');
          break;
        case 'notaFiscal':
          notify('error', 'Envie a Nota Fiscal da Venda.');
          break;
        default:
          notify('error', message);
          break;
      }
    });
  }
  useEffect(() => {
    if (data.length > 0) {
      const newList = data.map((item) => (
        {
          [`${String(item[2])}`]:
           {
             municipio: item[0],
             empreendimento: item[1],
             cpfcnpj: item[2],
             endereco: String(item[3]).replace('ï¿½', 'ú'),
             registro: String(item[4]).split('Validade')[0].substring(0, String(item[4]).split('Validade')[0].length - 2),
             validade: String(item[4]).split('Validade')[1],
             atividade: item[5],
             situacao: item[6],
           },
        }
      ));
      setNewObj(newList);
    }
  }, [data]);

  useEffect(() => {
    if (!uid) {
      history.push('/coleta');
    }
  }, []);

  useEffect(() => {
    if (newObj.length > 0) {
      console.log(JSON.stringify(newObj, null, 2));
    }
  }, [newObj]);

  useEffect(() => {
    try {
      const {
        decaAplicador: { valor: decaAplicadorIsValid },
        decaProdutor: { valor: decaProdutorIsValid },
        receituario: { valor: receituarioIsValid },
        notaFiscal: { valor: notaFiscalIsValid },
      } = cliente.uploadCompleted;
      // console.log(cliente.uploadCompleted);
      if (decaAplicadorIsValid && decaProdutorIsValid && receituarioIsValid && notaFiscalIsValid) {
        if (cliente.uid) {
          updateUser();
        }
      }
    } catch (error) {
      if (error.message) {
        console.log('Cliente not Found');
      }
    }
  }, [cliente.uploadCompleted]);

  const cpfMask = (value) => value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada

  const cnpjMask = (value) => {
    const x = value
      .replace(/\D/g, '')
      .match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
    return !x[2]
      ? x[1]
      : `${x[1]}.${x[2]}.${x[3]}/${x[4]}${x[5] ? `-${x[5]}` : ''}`;
  };

  const setInfo = ({ target }) => {
    const { name, value, type } = target;
    let newValue = value;
    if (value.length <= 14 && name === 'cpfcnpj') {
      newValue = cpfMask(value);
    } else if (value.length > 14 && name === 'cpfcnpj') {
      newValue = cnpjMask(value);
    }
    if (type === 'checkbox') {
      const itemExistis = cliente.modalidade.some((item) => item[name]?.key === name);
      if (itemExistis) {
        const modalidade = cliente.modalidade.filter((item) => item[name]?.key !== name && item);
        setCliente((prevState) => ({
          ...prevState,
          modalidade,
        }));
      } else {
        setCliente((prevState) => ({
          ...prevState,
          modalidade: [
            ...prevState.modalidade,
            {
              [name]: {
                nome: value,
                key: name,
              },
            },
          ],
        }));
      }
    } else {
      setCliente((prevState) => ({
        ...prevState, [name]: newValue, uid: uuid(),
      }));
    }
  };
  function buscarCadastro() {
    const { cpfcnpj } = cliente || null;
    const result = Dados.filter((item) => Object.keys(item)[0] === cpfcnpj
     && item[`${Object.keys(item)[0]}`])[0];
    let retorno = {};
    try {
      if (result[`${cpfcnpj}`].situacao === 'SUSPENSO') {
        setShowMessage({
          cliente: result[`${cpfcnpj}`].empreendimento,
          show: true,
        });
        return setTimeout(() => {
          setShowMessage({
            cliente: '',
            show: false,
          });
        }, 5000);
      }
      retorno = result[`${cpfcnpj}`];
      notify('success', 'Cliente localizado');
    } catch (error) {
      if (error.message) {
        retorno = {
          empreendimento: 'Não encontrado',
          culturaTratada: 'Algodão',
          produtoAplicado: 'Ad Foliar',
          uid: '',
          uploadCompleted: {
            decaAplicador: { valor: false },
            decaProdutor: { valor: false },
            receituario: { valor: false },
            notaFiscal: { valor: false },
          },
          modalidade: [],
          filesUpload: {
            decaAplicador: [],
            decaProdutor: [],
            receituario: [],
            notaFiscal: [],
          },
          cpfcnpj: '',
        };
        notify('warning', 'Cliente não localizado');
      }
    }
    setCliente({
      ...retorno,
      culturaTratada: 'Algodão',
      produtoAplicado: 'Ad Foliar',
      urlVenda: '',
      uid: uuid(),
      uploadCompleted: {
        decaAplicador: { valor: false },
        decaProdutor: { valor: false },
        receituario: { valor: false },
        notaFiscal: { valor: false },
      },
      modalidade: [],
      filesUpload: {
        decaAplicador: [],
        decaProdutor: [],
        receituario: [],
        notaFiscal: [],
      },
    });
    return null;
  }
  function handleFile(file /*: File */) {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array' });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      // const data = XLSX.utils.sheet_to_json(ws, {
      //   header: 1,
      // });
      /* Update state */
      setData(XLSX.utils.sheet_to_json(ws, {
        header: 1,
      }));
      // this.setState({ data, cols: make_cols(ws['!ref']) });
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  }
  function handleChange(e) {
    const { files } = e.target;
    if (files && files[0]) handleFile(files[0]);
  }
  function vendaViwer() {
    return (
      <>
        <Certificado props={{ clienteUid: cliente.uid, userUid: uid }} />
        {screen !== 'sale'
          ? (
            <div id="venda-confirmada">
              <img src={VendaConfirmada} alt="Venda Confirmada" />
              <strong>
                Venda orientada realizada com sucesso !
              </strong>
              <span>
                Sua venda foi registrada e o comprador foi
                notificado com a Certificação de Conformidade.
              </span>
              <div className="botoes-venda">
                <button
                  type="button"
                  className="buttons-transparent"
                  onClick={() => setCliente({
                    empreendimento: 'Não encontrado',
                    culturaTratada: 'Algodão',
                    produtoAplicado: 'Ad Foliar',
                    uuid: '',
                    uploadCompleted: {
                      decaAplicador: { valor: false },
                      decaProdutor: { valor: false },
                      receituario: { valor: false },
                      notaFiscal: { valor: false },
                    },
                    modalidade: [],
                    filesUpload: {
                      decaAplicador: [],
                      decaProdutor: [],
                      receituario: [],
                      notaFiscal: [],
                    },
                  }, history.push('/coleta'))}
                >
                  <i className="fas fa-arrow-left">
                    <span>
                      Menu principal
                    </span>
                  </i>

                </button>
                <button
                  type="button"
                  className="buttons-transparent"
                  data-toggle="modal"
                  data-target="#modal-certificado"
                >
                  <i className="fas fa-clipboard-check">
                    <span>
                      Verificar Certificado
                    </span>
                  </i>
                </button>
              </div>
            </div>
          )
          : (
            <div id="main-new-sale">
              <div className="title-new-sale">
                <strong>
                  (+) Registrar nova venda
                </strong>
                <span>
                  Venda orientada em conformidade com a INSTRUÇÃO NORMATIVA SEAPDR nº 09/2019
                </span>
              </div>
              <div className="separator">
                ...
              </div>
              {(cliente.empreendimento === 'Não encontrado') && (
              <div className="content-cpf-cnpj">
                <span>
                  CPF/CNPJ*
                </span>
                <div className="dados-input">
                  <input
                    type="text"
                    id="cpfcnpj"
                    name="cpfcnpj"
                    placeholder="Informe o CPF ou CNPJ"
                    value={cliente.cpfcnpj}
                    onChange={setInfo}
                  />
                  <span>
                    Digite o CPF/CNPJ do aplicador de defensivo ou estabelecimento rural.
                  </span>
                </div>
              </div>
              )}
              {(cliente.empreendimento !== 'Não encontrado') && (
              <div className="cliente-localizado">
                <label id="label-latitude" className="empreendimento">
                  <span>
                    Aplicador/Estabelecimento Rural
                  </span>
                  <input
                    onChange={(e) => setCliente((prevState) => ({
                      ...prevState,
                      empreendimento: e.target.value,
                    }))}
                    value={cliente.empreendimento}
                    type="text"
                    id="empreendimento"
                    name="empreendimento"
                    placeholder="Aplicador/Estabelecimento Rural"
                  />
                </label>
                <label id="label-dataCompra" className="dataCompra">
                  <span>
                    Data da Compra
                  </span>
                  <input
                    type="date"
                    id="dataCompra"
                    name="dataCompra"
                    value={cliente.dataCompral}
                    onChange={(e) => {
                      setCliente((prevState) => (
                        {
                          ...prevState,
                          dataCompra: InverterDataAtualUS(e.target.value),
                        }
                      ));
                    }}
                  />
                </label>
                <label id="label-telefone" className="telefone">
                  <span>
                    Telefone
                  </span>
                  <input
                    type="text"
                    id="telefone"
                    name="telefone"
                    placeholder="Telefone"
                    value={cliente.telefone}
                    onChange={(e) => {
                      setCliente((prevState) => (
                        {
                          ...prevState,
                          telefone: FormataTelefone(e.target.value),
                        }
                      ));
                    }}
                  />
                </label>
                <label id="label-culturaTratada" className="culturaTratada">
                  <span>
                    Cultura Tratada
                  </span>
                  <select
                    className="form-control"
                    name="culturaTratada"
                    id="culturaTratada"
                    onChange={(e) => {
                      setCliente((prevState) => ({
                        ...prevState,
                        culturaTratada: e.target.value,
                      }));
                    }}
                  >
                    <option value="Algodão">Algodão</option>
                    <option value="Arroz">Arroz</option>
                    <option value="Banana">Banana</option>
                    <option value="Batata">Batata</option>
                    <option value="Cana-de-açúcar">Cana-de-açúcar</option>
                    <option value="Citrus">Citrus</option>
                    <option value="Milheto">Milheto</option>
                    <option value="Milho">Milho</option>
                    <option value="Soja">Soja</option>
                    <option value="Tabaco">Tabaco</option>
                    <option value="Uva">Uva</option>
                  </select>
                </label>
                <label id="label-produtoAplicado" className="produtoAplicado">
                  <span>
                    Produto Aplicado
                  </span>
                  <select
                    className="form-control"
                    name="produtoAplicado"
                    id="produtoAplicado"
                    onChange={(e) => {
                      setCliente((prevState) => ({
                        ...prevState,
                        produtoAplicado: e.target.value,
                      }));
                    }}
                  >
                    <option value="Ad Foliar">Ad Foliar</option>
                    <option value="Adjuvante">Adjuvante</option>
                    <option value="Fungicida">Fungicida</option>
                    <option value="Herbicida">Herbicida</option>
                    <option value="Herbicida de Catação">Herbicida de Catação</option>
                    <option value="Inseticida">Inseticida</option>
                    <option value="Maturador">Maturador</option>
                    <option value="Pré-Maturador">Pré-Maturador</option>
                    <option value="Outro">Outro</option>
                  </select>
                </label>
                <div className="checkbox">
                  <div className="modalidade">
                    <span>
                      Modalidade
                    </span>
                  </div>
                  <div className="option-check-box">
                    <div className="item-check">
                      <input
                        type="checkbox"
                        value="Aérea"
                        id="aerea"
                        name="aerea"
                        onClick={(e) => setInfo(e)}
                      />
                      <span>Aérea</span>
                    </div>
                    <div className="item-check">
                      <input
                        type="checkbox"
                        value="Aérea Drones"
                        id="aereaDrones"
                        name="aereaDrones"
                        onClick={(e) => setInfo(e)}
                      />
                      <span>Aérea Drones</span>
                    </div>
                    <div className="item-check">
                      <input
                        type="checkbox"
                        value="Costal"
                        id="costal"
                        name="costal"
                        onClick={(e) => setInfo(e)}
                      />
                      <span>Costal</span>
                    </div>
                    <div className="item-check">
                      <input
                        type="checkbox"
                        value="Terrestre"
                        id="terrestre"
                        name="terrestre"
                        onClick={(e) => setInfo(e)}
                      />
                      <span>Terrestre</span>
                    </div>
                  </div>
                </div>
                <div className="files-upload">
                  <DragAndDrop share={{ cliente, setCliente, item: 'decaAplicador' }} />
                  <DragAndDrop share={{ cliente, setCliente, item: 'decaProdutor' }} />
                  <DragAndDrop share={{ cliente, setCliente, item: 'receituario' }} />
                  <DragAndDrop share={{ cliente, setCliente, item: 'notaFiscal' }} />
                </div>

              </div>
              )}
              <div className="separator">
                ...
              </div>
              {(cliente.empreendimento === 'Não encontrado') && (
              <div className="footer-new-sale">
                {!showMessage.show && (
                <Button
                  onClick={() => buscarCadastro()}
                >
                  Consultar
                </Button>
                )}
                { showMessage.show && (
                  <>
                    <img src={InvalidImg} alt="Inválido" />
                    <span className="atencao">
                      ATENÇÃO COMERCIANTE!
                    </span>
                    <span className="a-venda">
                      A venda de insumo hormonal está proibida para o cliente
                      <span className="destaque">
                        {' '}
                        {showMessage.cliente}
                      </span>
                      ,
                      devido o registro junto a SECRETARIA DA AGRICULTURA,
                      PECUÁRIA E DESENVOLVIMENTO RURAL – SEAPDR está
                      {' '}
                      <span className="destaque">
                        SUSPENSO
                      </span>
                    </span>
                    <span className="para-realizar">
                      Para realizar a compra de insumo hormonal é necessário que o
                      cliente regularize sua situação junto a SEAPDR
                    </span>
                    <span className="caso">
                      *CASO SEJA REALIZADA A VENDA DE INSUMO HORMONAL VOCE ESTA
                      INFRINGINDO O DISPOSTO DA IN 09/2019, PODENDO SER MULTADO EM
                      CASO DE FISCALIZAÇÃO.
                    </span>
                  </>
                )}
              </div>
              )}
              {(cliente.empreendimento !== 'Não encontrado') && (
              <div className="footer-new-sale-proximo">
                <Button
                  onClick={() => setCliente({
                    empreendimento: 'Não encontrado',
                    cpfcnpj: '',
                  })}
                >
                  Anterior
                </Button>
                <Button
                  onClick={() => enabledSave()}
                >
                  Salvar
                </Button>
              </div>
              )}
              {false && (
              <div className="form-group">
                <label htmlFor="file">Spreadsheet</label>
                <input
                  type="file"
                  className="form-control"
                  src="../"
                  id="file"
                  accept={SheetJSFT}
                  onChange={handleChange}
                />
              </div>
              )}
            </div>
          )}
      </>
    );
  }

  return (
    <>
      {saving
        ? (
          <div id="saving">
            <img src={Loader} alt="Carregando" />
            <span>Salvando venda, por favor aguarde...</span>
          </div>
        )
        : (
          vendaViwer()
        )}
    </>

  );
}

export default NewSale;
